import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './IncentiveMultiSelect.css'
import { faX } from '@fortawesome/free-solid-svg-icons';

export const IncentiveChip = (props:{label:string, onDelete:()=>void})=>{
    return (
        <div className='incentive-chip'>
            <div className='incentive-chip-label'>
                {props.label}
            </div>
            <div className='incentive-chip-delete-button'>
                <FontAwesomeIcon
                    icon={faX}
                    size='xs'
                    onClick={props.onDelete}
                />
            </div>
        </div>
    );
}